<template>
<div class="chapter">
<div class="inner_page">
<img src="05-chapter04.html.jpg" style="margin-left: 0px;"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05-chapter04.vue?3fba8fe2